import Swiper from 'swiper';

const stories = {
  storiesNode: null,
  storiesThumbNodes: null,

  init() {
    this.storiesNode = document.querySelector('.js-stories');
    this.storiesThumbNodes = Array.from(document.querySelectorAll('.js-stories-thumbs'));

    if(stories && (this.storiesThumbNodes && this.storiesThumbNodes.length > 0)) {
      new Swiper(this.storiesNode, {
        loop: true,
        slidesPerView: 1,
        initialSlide: 1,
        centeredSlides: true,
        spaceBetween: 32,
        autoHeight: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        autoplay: {
          delay: 6000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        breakpoints: {
          1280: {
            allowTouchMove: true,
          },
        },
        on: {
          init: () => this.handleChangeSlide(),
          slideChange: () => this.handleChangeSlide(),
        },
      });
    }
  },

  handleChangeSlide() {
    this.storiesThumbNodes.forEach(el => {
      const item = this.storiesNode.querySelector(`.swiper-slide-${el.dataset.position} .p-home-story`);
      this.changeSlideInThumb(el, item);
    });
  },

  changeSlideInThumb(thumb, item) {
    if(thumb && item) {
      const content = item.cloneNode(true);
      content.classList.add('p-home-story--small');

      while (thumb.firstChild) {
        thumb.removeChild(thumb.firstChild);
      }

      thumb.appendChild(content);
    }
  },
};

export default stories;



// WEBPACK FOOTER //
// ./scripts/modules/stories.js